import React, { useEffect, useState, useRef } from 'react';
import BOLayout from '@/pages/back-office/BOLayout';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import SettingsTopBanner from '@/components/back-office/SettingsTopBanner';

const CategoryEdition = () => {
    const [name, setName] = useState('');
    const [picture, setPicture] = useState(null);
    const [preview, setPreview] = useState(null);
    const pictureRef = useRef(null);
    const navigate = useNavigate();
    const { categoryId } = useParams();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${import.meta.env.VITE_API_URL}/api/settings/categories/${categoryId}/view`);
                if (response.status === 200) {
                    setName(response.data.name);
                    if (response.data.picture_url) {
                        setPreview(response.data.picture_url);
                    }
                }
            } catch (error) {
                console.error('Error fetching category:', error);
            }
        };

        fetchData();
    }, [categoryId]);

    const handlePicture = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPicture(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('name', name);
        if (picture) {
            formData.append('picture', picture);
        }

        try {
            const response = await axios.put(
                `${import.meta.env.VITE_API_URL}/api/back-office/settings/categories/${categoryId}/update`, 
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            if (response.status === 200) {
                toast.success('Catégorie modifiée avec succès', {
                    position: 'top-center',
                    autoClose: 800,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    theme: 'colored',
                });
                navigate('/back-office/settings/categories/list');
            }
        } catch (error) {
            console.error('Error editing category:', error);
            toast.error('Une erreur est survenue', {
                position: 'top-center',
                autoClose: 800,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                theme: 'colored',
            });
        }
    };

    return (
        <BOLayout>
            <div className="mb-12 grid grid-cols-1 gap-12">
                <SettingsTopBanner />
                <h1 className="text-3xl font-bold text-center">Modifier la catégorie</h1>
            </div>
            <form onSubmit={handleSubmit} className="text-center">
                {preview && (
                    <img 
                        src={preview} 
                        alt="Aperçu" 
                        className="mb-4 mx-auto border border-black p-2 rounded-lg w-[150px] h-[150px] object-cover"
                    />
                )}

                <div
                    className="mb-4 mx-auto flex items-center border border-black p-2 rounded-lg w-1/4 text-sm hover:cursor-pointer"
                    onClick={() => pictureRef.current.click()}
                >
                    <input 
                        type="file" 
                        accept="image/*"
                        name="picture" 
                        id="picture" 
                        className="hidden" 
                        ref={pictureRef} 
                        onChange={handlePicture} 
                    />
                    <img src="/src/assets/media/pictures/import.png" alt="" width={30} className="mr-2" />
                    <label className="hover:cursor-pointer">Téléchargez l'image de votre catégorie</label>
                </div>

                <div className="flex flex-col mb-4">
                    <label htmlFor="name" className="text-left pl-2">Nom</label>
                    <input 
                        type="text" 
                        id="name" 
                        value={name} 
                        onChange={(e) => setName(e.target.value)} 
                        className="mb-4 border border-black p-2 rounded-lg"
                        required 
                    />
                </div>
                <button 
                    type="submit" 
                    className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary/80 transition duration-300"
                >
                    Modifier
                </button>
            </form>
        </BOLayout>
    );
};

export default CategoryEdition;